import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { clearEmailAction } from "src/store/actions/emailTemplatesActions/emailTempActions";
import API from "../../../../network";
import EmailActionModel from "./emailActionModel";

const EmailActionExecutor = () => {
  const emailAction = useSelector((state) => state.emailActionReducer);
  const dispatch = useDispatch();

  const [message, setMessage] = useState("");
  const [open, setOpen] = useState(false);

  const handleClose = () => setOpen(false);

  useEffect(() => {
    if (!emailAction || emailAction.action !== "unsubscribe") return;

    const handleAction = async () => {
      try {
        const email = emailAction.emailId;

        const res = await API.unsubscribe(encodeURIComponent(email));

        setMessage(res?.data);
        setOpen(true);

        dispatch(clearEmailAction());
      } catch (error) {
        console.error("Email action error:", error);

        setMessage("Something went wrong");
        setOpen(true);

        dispatch(clearEmailAction());
      }
    };

    handleAction();
  }, [emailAction, dispatch]);

  return (
    <>
      <EmailActionModel
        open={open}
        handleClose={handleClose}
        message={message}
      />
    </>
  );
};

export default EmailActionExecutor;